import { Center, Stack, Title, Text, Button, Paper } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';

export default function PendingActivation() {
  const { logout, user } = useAuth();

  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Paper shadow="md" p="xl" radius="md" w={440}>
        <Stack align="center" gap="lg">
          <IconClock size={48} color="var(--mantine-color-yellow-6)" />
          <Title order={3}>Account Pending Activation</Title>
          <Text c="dimmed" size="sm" ta="center">
            Your account ({user?.email}) has been created but is not yet active.
            An administrator needs to activate your account before you can access Meridian.
          </Text>
          <Button variant="subtle" onClick={logout}>
            Sign out
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
